import { shuffle } from "lodash"

export const gameIds = shuffle([
  80415, 80488, 80489, 80595, 80846, 80954, 80955, 80957, 80967, 81107, 81108,
  81109, 81110, 81111, 81149, 81169, 81170, 81171, 81172, 81213, 81214, 81215,
  81216, 81217, 81218, 81219, 81220, 81221, 81224, 81225, 81226, 81227, 81228,
  81229, 81319, 81320, 81321, 81322, 81323, 81324, 81325, 81326, 81327, 81328,
  81329, 81330, 81331, 81332, 81334, 81335, 81336, 81337, 81338, 81339, 81340,
  81341, 81342, 81343, 81344, 81345, 81346, 81347, 81348, 81349, 81350, 81351,
  81352, 81353, 81354, 81355, 81356, 81357, 81358, 81359, 81360, 81361, 81362,
  81363, 81364, 81365, 81366, 81367, 81368, 81369, 81370, 81371, 81372, 81373,
  81374, 81375, 81376, 81377, 81378, 81379, 81380, 81383, 81384, 81385, 81386,
  81387, 81388, 81389, 81390, 81391, 81392, 81393, 81394, 81395, 81465, 81467,
  81734, 81382, 81381, 81223,
])
